import styled from 'styled-components'

const ContactName = styled.div`
  font-size: 1.125rem;
  padding-bottom: 5px;
`

export default ContactName
